import { MaskedText, MaskedTextProps } from './components/MaskedText'
import {
  MaskedTextInput,
  MaskedTextInputProps,
} from './components/MaskedTextInput'

import { mask, unMask } from './utils/mask'

export { MaskedText, MaskedTextInput, mask, unMask }

export type { MaskedTextProps, MaskedTextInputProps }
